import { useEffect, useRef } from "react";
import toast from "react-hot-toast";
import type { PendingDuplication } from "./FileDuplicationProvider";

export function PendingDuplicationToast({
  item,
  retrying,
  onRetry,
}: {
  item: PendingDuplication;
  retrying: boolean;
  onRetry: () => void;
}) {
  const retryRef = useRef(onRetry);
  retryRef.current = onRetry;
  const id = `file-duplication-pending-${item.request.requestId}`;
  useEffect(() => {
    toast.error(
      <span className="flex flex-col items-start gap-2">
        <span>Could not confirm duplication of {item.label}.</span>
        <button
          type="button"
          data-preserve-open-modal="true"
          className="text-primary underline disabled:opacity-50"
          disabled={retrying}
          onClick={() => {
            retryRef.current();
          }}
        >
          {retrying ? "Checking…" : "Retry request"}
        </button>
      </span>,
      { id, duration: Infinity },
    );
  }, [id, item.label, retrying]);
  useEffect(
    () => () => {
      toast.remove(id);
    },
    [id],
  );
  return null;
}
